import {
    REQUEST_CUSTOMER_FAVORITES,
    FETCH_CUSTOMER_FAVORITES_SUCCESS,
    FETCH_CUSTOMER_FAVORITES_FAILURE,
    SELECT_CUSTOMER_FAVORITES,
    RESET_CURRENT_CUSTOMER_FAVORITES,
    REQUEST_CUSTOMER_FAVORITES_DETAIL,
    FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS,
    FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE,
    REQUEST_ADDING_CUSTOMER_FAVORITE,
    ADD_CUSTOMER_FAVORITE_SUCCESS,
    ADD_CUSTOMER_FAVORITE_FAILURE,
    REQUEST_DELETE_CUSTOMER_FAVORITE,
    DELETE_CUSTOMER_FAVORITE_SUCCESS,
    DELETE_CUSTOMER_FAVORITE_FAILURE,
    REQUEST_CUSTOMERS_WITH_FAVORITES,
    FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS,
    FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE,
    ITEM_IN_LIST,
    CLEAR_IN_LIST_ERROR
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentFavorites: null,
    currentFavoritesDetail: null,
    isLoading: false,
    error: null,
    favoritesAreLoading: false,
    favoritesError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    customersWithFavorites: [],
    customersWithFavoritesIsLoading: null,
    customersWithFavoritesError: null,
    inList: false,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Favorites action handlers
        case REQUEST_CUSTOMER_FAVORITES:
            return { ...state, error: null, isLoading: true };
        case FETCH_CUSTOMER_FAVORITES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_CUSTOMER_FAVORITES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_CUSTOMER_FAVORITES:
            return { ...state, currentFavorites: action.payload };
        case RESET_CURRENT_CUSTOMER_FAVORITES:
            return { ...state, currentFavorites: null };
        case REQUEST_CUSTOMER_FAVORITES_DETAIL:
            return { ...state, favoritesError: null, favoritesAreLoading: true };
        case FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentFavoritesDetail: action.payload.data, favoritesError: null, favoritesAreLoading: false };
        case FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE:// return error and make loading = false
            const favoritesError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], favoritesError: favoritesError, favoritesAreLoading: false };
        case REQUEST_ADDING_CUSTOMER_FAVORITE:
            return { ...state, error: null, isLoading: true};
        case ADD_CUSTOMER_FAVORITE_SUCCESS:
            return { ...state, isLoading: false };
        case ADD_CUSTOMER_FAVORITE_FAILURE:
            const favAddError = action.payload || { message: action.payload.message };
            return { ...state, error: favAddError, isLoading: false };
        case REQUEST_DELETE_CUSTOMER_FAVORITE:
            return { ...state, error: null, isLoading: true};
        case DELETE_CUSTOMER_FAVORITE_SUCCESS:
            return { ...state, isLoading: false};
        case DELETE_CUSTOMER_FAVORITE_FAILURE:
            return { ...state, error: error, isLoading: false};
        case REQUEST_CUSTOMERS_WITH_FAVORITES:
            return { ...state, customersWithFavoritesError: null, customersWithFavoritesIsLoading: true };
        case FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS:
            return { ...state, customersWithFavorites: action.payload.data, customersWithFavoritesError: null, customersWithFavoritesIsLoading: false };
        case FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE:
            const customersWithFavoritesError = action.payload;
            return { ...state, all: [], customersWithFavoritesError: customersWithFavoritesError, customersWithFavoritesIsLoading: false };
        case ITEM_IN_LIST:
            return { ...state, inList: true };
        case CLEAR_IN_LIST_ERROR:
            return { ...state, inList: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/favoriteList_reducer.jsx